//#region [IMPORT]

// === THIRD-PARTY ===
import React, { useState } from 'react';

// *** MUI / STYLING ***
import { useTheme } from '@mui/material/styles';
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,   
    DialogActions,
} from '@mui/material';

// === COMPONENTS ===
import { PanelVerifyData } from './components/PanelVerifyData.jsx';
import { PanelFileViewer } from './components/PanelFileViewer.jsx';
import Styled from 'components/Styled/Styled.jsx';

//#endregion

//-----------------------------------------------------------------
export function ShortcutDialog(props) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme = useTheme();

  const [ tab_selected, setTabSelected ] = useState( 1 );

  const is_verify_data = tab_selected === 1;
  const is_file_viewer = tab_selected === 2;

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
    },
    dialog : {
      '& .MuiDialog-container': {
        alignItems: 'flex-start', // Vertically aligns to the top instead of center
      },
    },
    tab_selected : {
      background: theme.palette.background.secondary[theme.palette.mode],
      color     : theme.palette.primary.main,
      '&:hover' : { backgroundColor: theme.palette.background.secondary[theme.palette.mode] }
    },
    tab : {
      borderRadius: '5px 5px 0px 0px',
      '&:hover' : { backgroundColor: 'transparent' }
    }
  }

  const CONTAINER = {
    sx : _styles.container,
  };

  const DIALOG = {
    sx             : _styles.dialog,
    fullWidth      : true,
    maxWidth       : 'lg',
    open           : props.showPopupDialog,
    onClose        : handleClose,
    ariaLabelledby : 'form-dialog-title',
  };

  const BUTTON_CLOSE = {
    color    : 'primary'   ,
    onClick  : handleClose ,
    children : [ 'Close' ] ,
    name     : 'close_shortcut_dialog_btn',   
  }

  //#endregion

  //#region [MODIFY]

  //-----------------------------------------------------------------
  function handleClose() {
    //-----------------------------------------------------------------
    props.setShowPopupDialog(false);
  };

  //#endregion

  //#region [DISPLAY]

  //-----------------------------------------------------------------
  function render() {
    //-----------------------------------------------------------------
    return (
      <div { ...CONTAINER } >
        <Dialog { ...DIALOG } >
          <DialogTitle id='form-dialog-title' variant='primary' sx={{ backgroundColor: theme.palette.background.primary[theme.palette.mode] }}>Keyboard Shortcuts & Controls</DialogTitle>
          
          <Styled>
            <Button disableRipple  sx={ { ..._styles.tab, ...(is_verify_data ? _styles.tab_selected : {}) } } onClick={ () => setTabSelected(1) }>Verify Data</Button>
            <Button disableRipple  sx={ { ..._styles.tab, ...(is_file_viewer ? _styles.tab_selected : {}) } } onClick={ () => setTabSelected(2) }>File Viewer</Button>
          </Styled>
          <DialogContent sx={{ width: '100%', backgroundColor: theme.palette.background.secondary[theme.palette.mode] }}>
            { 
              tab_selected === 1 ? <PanelVerifyData /> :
              tab_selected === 2 ? <PanelFileViewer /> :
              null
            }
          </DialogContent>
          <DialogActions sx={{ backgroundColor: theme.palette.background.secondary[theme.palette.mode] }}>
            <Button { ...BUTTON_CLOSE  } />
          </DialogActions>
        </Dialog> 
      </div>
    );
  }

  //#endregion

  return render();

}